/*
 * NEXZ V2 — homepage analytics (Stage I, doc 07). Same nexz:* event-hook
 * contract as nexz-pdp.js/nexz-collection.js/nexz-cart.js — no
 * destination wired here.
 *
 * Section IDs map to doc 07's S1-S8 via Shopify's standard
 * #shopify-section-<id> wrapper, matching the section keys authored in
 * templates/index.json (S0/announcement bar is tracked separately, not
 * part of this homepage-only contract).
 */
var EVENT_CONTRACT = ['hero_cta_click', 'section_view', 'rail_scroll', 'sign_up'];

var SECTION_MAP = {
  hero_promise: 'S1',
  drop_rail: 'S2',
  structure_proof: 'S3',
  pant_story: 'S4',
  set_offer: 'S5',
  reviews_featured: 'S6',
  faq_compact: 'S7',
  drop_capture: 'S8',
};

function nexzEmit(name, detail) {
  if (EVENT_CONTRACT.indexOf(name) === -1) return;
  document.dispatchEvent(new CustomEvent('nexz:' + name, { detail: detail || {}, bubbles: true }));
}

function initHeroCtaClick() {
  var hero = document.getElementById('shopify-section-hero_promise');
  if (!hero) return;
  hero.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a') : null;
    if (!link) return;
    nexzEmit('hero_cta_click', { href: link.getAttribute('href') });
  });
}

function initSectionView() {
  if (typeof IntersectionObserver === 'undefined') return;
  var seen = {};
  var observer = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (!entry.isIntersecting) continue;
      var id = entry.target.id.replace('shopify-section-', '');
      var label = SECTION_MAP[id];
      if (!label || seen[label]) continue;
      seen[label] = true;
      nexzEmit('section_view', { section: label });
      observer.unobserve(entry.target);
    }
  });
  Object.keys(SECTION_MAP).forEach(function (id) {
    var el = document.getElementById('shopify-section-' + id);
    if (el) observer.observe(el);
  });
}

function initRailScroll() {
  var rail = document.querySelector('#shopify-section-drop_rail [data-testid="resource-list-grid"]');
  if (!rail) return;
  var fired = false;
  rail.addEventListener(
    'scroll',
    function () {
      if (fired) return;
      fired = true;
      nexzEmit('rail_scroll', {});
    },
    { passive: true }
  );
}

// Native {% form 'customer' %} has no JS in the loop — it posts and
// reloads the page. form.posted_successfully? becomes true only on that
// post-submit reload, so checking for the rendered success state on
// load is the one correct place to fire this, not a submit listener.
function initDropCaptureSignUp() {
  var form = document.getElementById('nexz-drop-capture-form');
  if (!form) return;
  var success = form.querySelector('.nexz-drop-alerts-form__success');
  if (success) {
    nexzEmit('sign_up', { placement: 'drop_capture' });
  }
}

initHeroCtaClick();
initSectionView();
initRailScroll();
initDropCaptureSignUp();
